const productsSelectors = function() {
  const self = {};


  // selects products out of the root state shape
  // state.products
  const _select = function(state) {
    return state.products;
  };

  // selects product events out of the root state shape
  // state.products.events
  self.selectProductEvents = function(state) {
    const root = _select(state);
    return root.events;
  };

  // selects the product list error
  // state.products.error
  self.selectError = function(state) {
    const root = _select(state);
    return root.error;
  };

  // selects product events out of the root state shape
  // state.products.event search for event by productEventId
  self.selectProductEvent = function(state, productEventId) {
    const events = self.selectProductEvents(state);
    for (let i = 0; i < events.length; i++) {
      if (events[i].id === productEventId) return events[i];
    }

    // didnt find the event so return nil
    return null;
  };

  // selects product details out of the root state shape
  // state.products.details
  self.selectProductDetails = function(state) {
    const root = _select(state);

    return root.details;
  };

  // selects product details out of the root state shape
  // state.products.details
  self.selectProductDetailsArray = function(state) {
    const details = self.selectProductDetails(state);
    const array = [];
    const productEventIds = Object.keys(details);

    for (let i = 0; i < productEventIds.length; i++) {
      const detail = details[productEventIds[i]];
      array.push(detail);
    }

    return array;
  };

  // selects product details out of the root state shape
  // state.products.details search for event by productEventId
  self.selectProductDetail = function(state, productEventId) {
    const productDetails = self.selectProductDetails(state)[productEventId];

    if (productDetails !== undefined) {
      return productDetails;
    }
    return null;
  };

  // return all product types, even ones the client doesnt have
  self.selectAllProductTypes = function(state) {
    const productState = _select(state);

    return productState.allProductTypes;
  };

  // selects product event ids that are playing sound and should continue
  self.selectEventsPlayingSound = function(state) {
    const root = _select(state);

    return root.eventsPlayingSound;
  };

  // selects product event ids that have played sound
  self.selectEventsPlayedSound = function(state) {
    const root = _select(state);

    return root.eventsPlayedSound;
  };

  self.selectClientProductTypes = function(state) {
    const root = _select(state);

    return root.clientProductTypes;
  };

  self.selectClientSeverities = function(state) {
    return angular.copy(state.products.severities);
  };

  return self;
};


export default productsSelectors();
